import PortalIdParser from 'PortalIdParser';
const BASE_URL = 'external-options/v2';
export const makeExternalOptionsByIdUrl = (referenceType, objectTypeId) => objectTypeId ? `${BASE_URL}/fetch/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(referenceType)}` : `${BASE_URL}/fetch/${encodeURIComponent(referenceType)}`;
export const makeExternalOptionsSearchUrl = (referenceType, objectTypeId) => objectTypeId ? `${BASE_URL}/pagedFetch/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(referenceType)}?useIndexOffset=true` : `${BASE_URL}/pagedFetch/${encodeURIComponent(referenceType)}?useIndexOffset=true`;
export const getExternalOptionsByIdFetchQueryOptions = () => {
  return {
    // NOTE: `portalId` is required both as a query param and in the body of the POST request:
    //
    // 1. Query param: for requests made from `SalesSidebar` (gmail plugin),
    //    without which requests fail with a 400 "HubId is not present in any
    //    form on the request. Please provide a path param or a query param.")
    // 2. Body of the POST request: without which requests fail with a 400
    //    "Invalid input JSON...some of required attributes are not set [portalId]"
    portalId: PortalIdParser.get()
  };
};
export const getExternalOptionsByIdFetchOptions = (ids, referenceType, fetchOptions, objectTypeId) => {
  return objectTypeId ? {
    ids,
    includeDeleted: fetchOptions.includeDeleted,
    objectTypeId,
    portalId: PortalIdParser.get(),
    referenceType
  } : {
    ids,
    includeDeleted: fetchOptions.includeDeleted,
    portalId: PortalIdParser.get(),
    referenceType
  };
};
export const getExternalOptionSearchFetchOptions = (searchQuery, fetchOptions) => ({
  limit: searchQuery.count,
  q: searchQuery.query,
  offset: searchQuery.offset,
  portalId: PortalIdParser.get(),
  includeDeleted: fetchOptions.includeDeleted
});